import store from '../store'
import SweetAlert from 'sweetalert2'

export default {
  ParseNumber (input) {
    if (input === undefined) {
      return undefined
    }

    if (input === '') {
      return 0
    }

    var output
    output = input.replace(/\./g, '')
    output = output.replace(',', '.')
    output = output ? parseFloat(output) : 0

    return output
  },

  DisplayNumber(input) {
    if (input === undefined) {
      return ''
    }

    if (input === 0) {
      return '0'
    }

    var output
    output = (input === 0) ? '' : input.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0 })

    return output
  },

  ParseDate(date, format) {
    var delimiter = format[format.search('[.-]')]
    var formatLowerCase = format.toLowerCase()
    var formatItems = formatLowerCase.split(delimiter)
    var dateItems = date.split(delimiter)
    var monthIndex = formatItems.indexOf('mm')
    var dayIndex = formatItems.indexOf('dd')
    var yearIndex = formatItems.indexOf('yyyy')
    var month = parseInt(dateItems[monthIndex])
    month -= 1
    var formatedDate = new Date(dateItems[yearIndex], month, dateItems[dayIndex])
    return formatedDate
  },
  DisplayDate(date, format) {
    if (!date) {
      return
    }
    var output = ''
    var formatLowerCase = format.toLowerCase()

    var day = this.NumberPad(date.getDate(), 2)
    var month = this.NumberPad(date.getMonth() + 1, 2)
    var year = this.NumberPad(date.getFullYear(), 4)
    output = formatLowerCase.replace('dd', day)
    output = output.replace('mm', month)
    output = output.replace('yyyy', year)

    return output
  },

  DisplayDateTime(date, format) {
    if (!date) {
      return
    }
    var output = ''
    var formatLowerCase = format.toLowerCase()

    var day = this.NumberPad(date.getDate(), 2)
    var month = this.NumberPad(date.getMonth() + 1, 2)
    var year = this.NumberPad(date.getFullYear(), 4)
    output = formatLowerCase.replace('dd', day)
    output = output.replace('mm', month)
    output = output.replace('yyyy', year)

    return output
  },

  NumberPad (number, size) {
    var s = String(number)
    while (s.length < (size || 2)) { s = '0' + s }
    return s
  },

  IsMenuAuthorized(menuName) {
    var isAuthorized = false
    var authMenu = store.getters.user ? store.getters.user.authorizationProfile.authMenu : []
    var skipMenuNonAdmin = ['Company', 'Project', 'Bank', 'User', 'User Form', 'Role', 'AuthObject', 'AuthField']
    if (authMenu) {
      var item = authMenu.find(x => x.name === '*') ||
                 authMenu.find(x => x.name === menuName)
      if (item) {
        isAuthorized = true
        var itemSkipNonAdmin = skipMenuNonAdmin.find(x => x === menuName)
        if (item.description === 'All Non Admin') {
          if (itemSkipNonAdmin) {
            SweetAlert.fire('Menu Authorization Checking', 'You are not authorized to access this menu or page', 'warning')
          } else {
            isAuthorized = true
          }
        } else if (item.description === 'All Admin') {
          isAuthorized = true
        }
      } else {
        SweetAlert.fire('Menu Authorization Checking', 'You are not authorized to access this menu or page', 'warning')
      }
    }
    return isAuthorized
  },

  IsObjectAuthorized(authObjectName, authFieldName, value) {
    var isAuthorized = false
    var authObject = store.getters.user ? store.getters.user.authorizationProfile.authObject : []
    if (authObject) {
      var item = authObject.find(x => x.authObjectName === '*' && x.authFieldName === '*' && x.value === '*') ||
                 authObject.find(x => x.authObjectName === authObjectName && x.authFieldName === '*' && x.value === '*') ||
                 authObject.find(x => x.authObjectName === authObjectName && x.authFieldName === authFieldName && x.value === '*') ||
                 authObject.find(x => x.authObjectName === authObjectName && x.authFieldName === authFieldName && x.value === value)
      if (item) {
        isAuthorized = true
      } else {
        var arrMessage = []
        arrMessage.push('You are not authorized to perform this action/activity !')
        arrMessage.push('System checking: auth object => ' + authObjectName + ', auth field => ' + authFieldName + ' and value => ' + value)
        SweetAlert.fire('Authorization Object Checking', arrMessage.join('<br>'), 'warning')
      }
    }
    return isAuthorized
  }
}



// WEBPACK FOOTER //
// ./src/utilities/index.js